import React, { memo } from 'react'

import CustomerHelpDesk from '../../../components/userAccount/CustomerHelpDesk'

const CustomerHelpDeskWrapper = (props) => {
  return <CustomerHelpDesk {...props} />
}

export default memo(CustomerHelpDeskWrapper)
